import * as z from 'zod/mini';
export function defineFormInput(definition) {
    const inputShape = { type: z.literal(definition.type), ...definition.input };
    const valueShape = { type: z.literal(definition.type), ...definition.value };
    const input = z.object(inputShape);
    const value = z.object(valueShape);
    return {
        type: definition.type,
        input: definition.description ? input.check(z.describe(definition.description)) : input,
        value,
    };
}
//# sourceMappingURL=defineFormInput.js.map